import { apiRequest } from "./apiClient";
import { rt } from "../i18n/runtime";

export const DEFAULT_AUTOMATION_RULES = [
  {
    key: "shoppingReminder",
    icon: "🛒",
    title: rt("auto.shopping.title"),
    description: rt("auto.shopping.desc"),
    enabled: true,
    options: {
      onlyIfPendingItems: true,
      oncePerDay: true,
    },
  },
  {
    key: "taskReminder",
    icon: "📋",
    title: rt("auto.task.title"),
    description: rt("auto.task.desc"),
    enabled: true,
    options: {
      today: true,
      tomorrow: true,
      threeDaysBefore: true,
      overdue: false,
    },
  },
  {
    key: "calendarReminder",
    icon: "📅",
    title: rt("auto.calendar.title"),
    description: rt("auto.calendar.desc"),
    enabled: true,
    options: {
      today: true,
      tomorrow: true,
      thisWeek: true,
    },
  },
  {
    key: "documentExpiry",
    icon: "📁",
    title: rt("auto.document.title"),
    description: rt("auto.document.desc"),
    enabled: true,
    options: {
      thirtyDays: true,
      tenDays: true,
      fiveDays: true,
      tomorrow: true,
      today: true,
      expired: true,
    },
  },
  {
    key: "healthReminder",
    icon: "❤️",
    title: rt("auto.health.title"),
    description: rt("auto.health.desc"),
    enabled: true,
    options: {
      appointments: true,
      medicines: true,
    },
  },
  {
    key: "financeReminder",
    icon: "💰",
    title: rt("auto.finance.title"),
    description: rt("auto.finance.desc"),
    enabled: true,
    options: {
      installments: true,
      subscriptions: true,
      bills: true,
    },
  },
];

const defaultsByKey = () =>
  DEFAULT_AUTOMATION_RULES.reduce((acc, rule) => {
    acc[rule.key] = rule;
    return acc;
  }, {});

const mergeRule = (base, data = {}) => ({
  ...base,
  ...data,
  options: {
    ...(base.options || {}),
    ...(data.options || {}),
  },
});


export async function otomatikBildirimKurallariniGetir() {
  const data = await apiRequest("/notifications/admin/automation/rules");
  const byKey = defaultsByKey();
  (data?.items || []).forEach((item) => {
    const key = item.key || item.id;
    byKey[key] = mergeRule(byKey[key] || { key }, { ...item, key });
  });
  return DEFAULT_AUTOMATION_RULES.map((rule) => mergeRule(rule, byKey[rule.key] || {}));
}

export async function otomatikBildirimKuraliniKaydet(ruleKey, data = {}) {
  await apiRequest(`/notifications/admin/automation/rules/${encodeURIComponent(ruleKey)}`, {
    method: "PUT",
    body: JSON.stringify({ key: ruleKey, ...data }),
  });
}

export async function otomatikBildirimKuraliniGuncelle(ruleKey, data = {}) {
  return otomatikBildirimKuraliniKaydet(ruleKey, data);
}

export async function otomatikBildirimLoglariniGetir(adet = 20) {
  const data = await apiRequest(`/notifications/admin/automation/logs?limit=${adet}`);
  return data?.items || [];
}

export async function otomatikBildirimDurumunuGetir() {
  const [logs, summaryData] = await Promise.all([
    otomatikBildirimLoglariniGetir(100),
    apiRequest("/notifications/admin/automation/summary"),
  ]);
  return { logs, sonCalisma: logs[0] || null, ozet: summaryData?.summary || {} };
}

export async function otomatikBildirimGonderimleriniGetir(logId) {
  if (!logId) return [];
  const data = await apiRequest(`/notifications/admin/automation/logs/${encodeURIComponent(String(logId))}/deliveries`);
  return data?.items || [];
}

export async function otomatikBildirimleriSimdiCalistir() {
  return apiRequest("/notifications/admin/automation/run-now", { method: "POST", body: JSON.stringify({ limit: 250 }) });
}

export async function tekrarEdenSistemDuyurulariniGetir(adet = 50) {
  const data = await apiRequest(`/notifications/admin/automation/repeating-announcements?limit=${adet}`);
  return data?.items || [];
}

export async function tekrarEdenSistemDuyurusunuGuncelle(id, data = {}) {
  if (!id) return;
  await apiRequest(`/notifications/scheduled/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export async function tekrarEdenSistemDuyurusunuIptalEt(id) {
  if (!id) return;
  await apiRequest(`/notifications/scheduled/${encodeURIComponent(id)}`, { method: "DELETE" });
}
